.infoText {
  margin: 14px;
}
